<template>
    <div class="space-y-2">
        <h2 class="uppercase text-sm text-zinc-400">Chroma</h2>
        <ItemDropdown
            label="Multiplier"
            v-model="selectMultiplierType"
            :options="[
                {value: 'none', label: 'None'},
                {value: 'standard', label: 'Standard'},
                {value: 'relative', label: 'Relative'},
            ]"
        />
    </div>
</template>

<script>
import ItemDropdown from './ItemDropdown.vue'
import { store } from '../store.js'
import { computed } from 'vue'

export default {
    name: 'SectionChroma',
    components: {
        ItemDropdown
    },
    setup() {
        const selectMultiplierType = computed( {
            get: () => store.multiplierType,
            set: (value) => store.setMultiplierType(value) 
        })
        return {
            selectMultiplierType
        }
    }

}

</script>